import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { useStateValue } from 'context/store';
import { setTab } from 'context/tabs/actions';

const DockMenuItem = styled.button`
  border: none;
  background: #ffec00;
  padding: 0 28px;

  ${({ isActive }) =>
    !isActive &&
    css`
      color: #707070;
      background: transparent;

      svg {
        fill: #707070;
      }
    `}
`;

function Item(props) {
  const { Icon, title, id, currentTab, setActiveTab } = props;
  const { dispatch } = useStateValue();
  const history = useHistory();
  const { pathname } = useLocation();
  const [isActive, setActive] = useState(false);

  useEffect(() => {
    if (id === currentTab) {
      setActive(true);
    } else {
      setActive(false);
    }
    //  eslint-disable-next-line
  }, [currentTab]);

  function setContentTab(tab) {
    if (pathname !== '/') {
      history.push('/');
    }
    window.scrollTo({ top: 591, behavior: 'smooth' });
    dispatch(setTab(tab));
    setActiveTab(id);
  }

  return (
    <DockMenuItem onClick={() => setContentTab(id)} isActive={isActive}>
      <Icon />
      <h6>{title}</h6>
    </DockMenuItem>
  );
}

export default Item;
